
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.133 5.235a.614.614 0 000 .762l5.209 6.042-5.21 6.05c-.175.204-.168.557-.006.744a.398.398 0 00.332.167.419.419 0 00.325-.156l5.54-6.427a.568.568 0 00.134-.378.568.568 0 00-.135-.377l-5.54-6.427a.422.422 0 00-.505-.115.42.42 0 00-.144.115z","fill":"#50657c"}})])
          )
        }
      }
    